// extracted by mini-css-extract-plugin
module.exports = {"container":"Bio_container__hN_Zs","image":"Bio_image__JLXN5","details":"Bio_details__sqrUk","description":"Bio_description__BlgMS","subtitle":"Bio_subtitle__o6YnF"};